import React from 'react';
import CouponDetails from './Components/CouponDetails';

const CouponDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <CouponDetails />
      </div>
    </div>
  );
};

export default CouponDetailsPage;
